import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/ma2.png';
import styles from '../styles/legal.module.css';
import { 
  FaSearch, 
  FaMapMarkerAlt, 
  FaArrowRight, 
  FaLeaf,
  FaTag,
  FaHeart,
  FaStore,
  FaInstagram,
  FaWhatsapp,
  FaChevronLeft,
  FaChevronRight,
  FaTimes
} from 'react-icons/fa';

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.legalContainer}>

      {/* HEADER */}
      <header className={styles.legalHeader}>
        <div className={styles.legalHeaderContainer}>
          <Link to="/" className={styles.legalLogo}>
            <img src={logo} alt="Mercado Abierto" className={styles.legalLogoImg} />
          </Link>
        </div>
      </header>

    <main className={styles.legalMainContent}>
  <div className={styles.legalContent}>
    
    <button onClick={() => navigate('/')} className={styles.backButton}>
      ← Volver al inicio
    </button>

    <h1 className={styles.legalTitle}>Aviso de Privacidad</h1>
    <p className={styles.legalDate}>Última actualización: 23 de junio de 2026</p>

    <div className={styles.legalSection}>
      <h2>1. Responsable de los datos</h2>
      <p>
        MercadoAbierto.online (en adelante "la Plataforma") es un sitio web de 
        carácter informativo que muestra información sobre mercados, locales, 
        productos, servicios y <strong>locatarios</strong> (comerciantes que ocupan y atienden los locales) en la república mexicana.
      </p>
      <p>
        Para efectos del presente Aviso de Privacidad, la Plataforma actúa como 
        un intermediario tecnológico que no recolecta, almacena ni procesa datos 
        personales de los usuarios, salvo aquellos que el usuario decida 
        proporcionar voluntariamente a través de los mecanismos de contacto 
        disponibles.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>2. Datos que no recopilamos</h2>
      <p>
        MercadoAbierto.online <strong>NO recopila, almacena ni procesa</strong> 
        datos personales de sus usuarios, incluyendo pero no limitado a:
      </p>
      <ul>
        <li>Nombre completo</li>
        <li>Dirección de correo electrónico</li>
        <li>Número telefónico</li>
        <li>Dirección física</li>
        <li>Datos de pago o financieros</li>
        <li>Ubicación geográfica (a menos que sea proporcionada voluntariamente por el usuario)</li>
      </ul>
      <p>
        La Plataforma únicamente muestra información pública proporcionada por 
        los administradores de los mercados y <strong>locatarios</strong>, quienes son responsables 
        de la veracidad y actualización de dicha información.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>3. Datos que sí recopilamos</h2>
      <p>
        La Plataforma puede recopilar datos de navegación anónimos con fines 
        estadísticos y de mejora del servicio:
      </p>
      <ul>
        <li>Dirección IP (anonimizada)</li>
        <li>Tipo de navegador y dispositivo</li>
        <li>Páginas visitadas dentro de la Plataforma</li>
        <li>Tiempo de permanencia en el sitio</li>
      </ul>
      <p>
        Estos datos no permiten identificar personalmente a los usuarios y 
        se utilizan únicamente para mejorar la experiencia de navegación.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>4. Cookies y tecnologías similares</h2>
      <p>
        MercadoAbierto.online utiliza cookies técnicas necesarias para el 
        funcionamiento básico del sitio web. No utilizamos cookies de 
        seguimiento ni de publicidad comportamental.
      </p>
      <p>
        El usuario puede configurar su navegador para rechazar todas las 
        cookies o para recibir una notificación cuando se instale una cookie.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>5. Enlaces a sitios de terceros</h2>
      <p>
        La Plataforma puede contener enlaces a sitios web de terceros, como 
        Google Maps u otros servicios externos. MercadoAbierto.online no es 
        responsable de las prácticas de privacidad de dichos sitios.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>6. Seguridad</h2>
      <p>
        MercadoAbierto.online implementa medidas de seguridad técnicas y 
        organizativas para proteger la información contra pérdida, uso 
        indebido o acceso no autorizado.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>7. Derechos de los usuarios</h2>
      <p>
        En cumplimiento con la Ley Federal de Protección de Datos Personales 
        en Posesión de los Particulares (LFPDPPP), los usuarios tienen derecho 
        a:
      </p>
      <ul>
        <li><strong>Acceso:</strong> Conocer qué datos personales se tienen</li>
        <li><strong>Rectificación:</strong> Corregir datos inexactos</li>
        <li><strong>Cancelación:</strong> Solicitar la eliminación de datos</li>
        <li><strong>Oposición:</strong> Oponerse al tratamiento de datos</li>
      </ul>
      <p>
        Para ejercer estos derechos, el usuario puede contactar a través del 
        correo: <strong>mercadoabierto@email.com</strong>
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>8. Legislación aplicable</h2>
      <p>
        El presente Aviso de Privacidad se rige por las leyes de los Estados 
        Unidos Mexicanos, en particular la Ley Federal de Protección de Datos 
        Personales en Posesión de los Particulares (LFPDPPP) y su Reglamento, 
        así como el Código Civil del Estado de Michoacán de Ocampo.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>9. Modificaciones</h2>
      <p>
        MercadoAbierto.online se reserva el derecho de modificar el presente 
        Aviso de Privacidad en cualquier momento. Las modificaciones serán 
        publicadas en esta misma página.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>10. Contacto</h2>
      <p>
        Para cualquier duda o aclaración sobre este Aviso de Privacidad, 
        puedes contactarnos en:
      </p>
      <p>
        <strong>Correo electrónico:</strong> mercadoabierto@email.com
      </p>
    </div>

  </div>
</main>

      {/* FOOTER */}
      <footer className={styles.legalFooter}>
        <div className={styles.legalFooterGrid}>
          <div>
            <img src={logo} alt="logo" className={styles.legalFooterLogo} />
            <p>Plataforma digital que conecta a los mercados municipales de México contigo.</p>
          </div>
          <div>
            <h4>Enlaces rápidos</h4>
            <p onClick={() => navigate('/')}>Inicio</p>
            <p onClick={() => navigate('/')}>Explorar mercados</p>
          </div>
          <div>
            <h4>Síguenos</h4>
            <div className={styles.socials}>
              <FaInstagram size={28} />
              <FaWhatsapp size={28} />
            </div>
          </div>
        </div>
        <div className={styles.mapFooterBottom}>
            © {new Date().getFullYear()} mercadoabierto.online - Todos los derechos reservados.
        </div>
      </footer>

    </div>
  );
};

export default Privacy;